import React from "react";
import { useTranslation } from "react-i18next";
import "../styles/global.css"; // assuming some basic styling or we can add it later

export function LanguageSelector() {
  const { i18n } = useTranslation();

  const changeLanguage = (event: React.ChangeEvent<HTMLSelectElement>) => {
    i18n.changeLanguage(event.target.value);
  };

  return (
    <div className="language-selector">
      <select value={i18n.language} onChange={changeLanguage} className="lang-select">
        <option value="en">EN</option>
        <option value="es-419">ES</option>
      </select>
    </div>
  );
}
